"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPS_CONDITION_PROPERTY = exports.CsatNpsExperimentType = exports.CSAT_FEEDBACK = exports.AbandonedCartOperator = exports.AbandonedCartType = exports.ProviderName = exports.PagesInterestTimeFrame = exports.SourceType = exports.DatalayerFieldNameV1Enum = exports.CheckModeTypes = void 0;
__exportStar(require("./transaction"), exports);
__exportStar(require("./datalayer"), exports);
__exportStar(require("./keyword"), exports);
var CheckModeTypes;
(function (CheckModeTypes) {
    CheckModeTypes["loading"] = "loading";
    CheckModeTypes["periodic"] = "periodic";
    CheckModeTypes["custom"] = "custom";
    CheckModeTypes["lastEntry"] = "last_entry";
})(CheckModeTypes = exports.CheckModeTypes || (exports.CheckModeTypes = {}));
var DatalayerFieldNameV1Enum;
(function (DatalayerFieldNameV1Enum) {
    DatalayerFieldNameV1Enum["check_mode"] = "check_mode";
    DatalayerFieldNameV1Enum["check_mode_latency"] = "check_mode_latency";
})(DatalayerFieldNameV1Enum = exports.DatalayerFieldNameV1Enum || (exports.DatalayerFieldNameV1Enum = {}));
var SourceType;
(function (SourceType) {
    SourceType[SourceType["Organic"] = 1] = "Organic";
    SourceType[SourceType["Referral"] = 2] = "Referral";
    SourceType[SourceType["Direct"] = 3] = "Direct";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
// PagesInterest
var PagesInterestTimeFrame;
(function (PagesInterestTimeFrame) {
    PagesInterestTimeFrame[PagesInterestTimeFrame["LastSession"] = -1] = "LastSession";
    PagesInterestTimeFrame[PagesInterestTimeFrame["PastTwoWeeks"] = 14] = "PastTwoWeeks";
    PagesInterestTimeFrame[PagesInterestTimeFrame["PastMonth"] = 30] = "PastMonth";
    PagesInterestTimeFrame[PagesInterestTimeFrame["PastYear"] = 390] = "PastYear";
})(PagesInterestTimeFrame = exports.PagesInterestTimeFrame || (exports.PagesInterestTimeFrame = {}));
// All Providers
var ProviderName;
(function (ProviderName) {
    ProviderName["FullStory"] = "fullstory";
    ProviderName["GoogleAnalytics4"] = "ga4audiences";
    ProviderName["HeapAnalytics"] = "heap";
    ProviderName["Mixpanel"] = "mixpanel";
    ProviderName["Segment"] = "segmentio";
    ProviderName["Tealium"] = "tealium";
    ProviderName["EmotionAI"] = "dotaki";
})(ProviderName = exports.ProviderName || (exports.ProviderName = {}));
// Abandoned Cart
var AbandonedCartType;
(function (AbandonedCartType) {
    AbandonedCartType["PRODUCT_NUMBER"] = "product number";
    AbandonedCartType["TOTAL_AMOUNT"] = "total amount";
})(AbandonedCartType = exports.AbandonedCartType || (exports.AbandonedCartType = {}));
var AbandonedCartOperator;
(function (AbandonedCartOperator) {
    AbandonedCartOperator["EQUAL"] = "equal";
    AbandonedCartOperator["GREATER"] = "greater";
    AbandonedCartOperator["LOWER"] = "lower";
    AbandonedCartOperator["BETWEEN"] = "between";
})(AbandonedCartOperator = exports.AbandonedCartOperator || (exports.AbandonedCartOperator = {}));
var CSAT_FEEDBACK;
(function (CSAT_FEEDBACK) {
    CSAT_FEEDBACK["POSITIVE"] = "positive";
    CSAT_FEEDBACK["NEUTRAL"] = "neutral";
    CSAT_FEEDBACK["NEGATIVE"] = "negative";
})(CSAT_FEEDBACK = exports.CSAT_FEEDBACK || (exports.CSAT_FEEDBACK = {}));
var CsatNpsExperimentType;
(function (CsatNpsExperimentType) {
    CsatNpsExperimentType["PERSONALIZATION"] = "personalization";
    CsatNpsExperimentType["CAMPAIGN"] = "campaign";
})(CsatNpsExperimentType = exports.CsatNpsExperimentType || (exports.CsatNpsExperimentType = {}));
var NPS_CONDITION_PROPERTY;
(function (NPS_CONDITION_PROPERTY) {
    NPS_CONDITION_PROPERTY["EQUALS"] = "equals";
    NPS_CONDITION_PROPERTY["GREATER"] = "equal_to_or_greater_than";
    NPS_CONDITION_PROPERTY["LOWER"] = "lower_than_or_equals";
    NPS_CONDITION_PROPERTY["BETWEEN"] = "between";
})(NPS_CONDITION_PROPERTY = exports.NPS_CONDITION_PROPERTY || (exports.NPS_CONDITION_PROPERTY = {}));
//# sourceMappingURL=index.js.map